// Google OAuth Web Client ID (public — safe in frontend).
// Prefer REACT_APP_GOOGLE_CLIENT_ID from .env when available.
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '63831296563-mmlmeh5repsg0rbgff2ue9d48u33o96d.apps.googleusercontent.com';
